"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { setSearchDraft } from "@/components/searchDraftStore";

/**
 * The board's keyword box. Controlled + synced to the URL's `q` so it always
 * reflects the active tab (fixes an uncontrolled input going stale after a
 * client-side tab switch), and broadcasts each keystroke to the search-draft
 * store so the active tab label writes itself as you type.
 */
export function SearchInput({
  id,
  placeholder,
  className,
}: {
  id: string;
  placeholder: string;
  className: string;
}) {
  const sp = useSearchParams();
  const urlQ = sp.get("q") ?? "";
  const [value, setValue] = useState(urlQ);

  // Follow the URL (tab switch, shared link, "clear search") — but not while
  // the user is mid-edit (they own the value then).
  useEffect(() => {
    setValue(urlQ);
  }, [urlQ]);

  return (
    <input
      id={id}
      type="search"
      name="q"
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        setSearchDraft(e.target.value);
      }}
      onFocus={(e) => setSearchDraft(e.currentTarget.value)}
      onBlur={() => setSearchDraft(null)}
      placeholder={placeholder}
      autoComplete="off"
      className={className}
    />
  );
}
